import React from 'react';
import Logo from '../Logo';
import Footer from '../Footer';
import Lock from '../Lock';
import { HOME_PAGE } from "../../constants";
import { Link } from 'react-router-dom';
import styled from 'styled-components';


const Container = styled.div`
  -webkit-app-region: drag;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

const Content = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Card = styled.div`
  -webkit-app-region: no-drag;
  margin-top: 30px; 
`;

export default () => {

  return (
    <Container>
      <Content>
        <Card>
          <div className="flex-center-column full-width">
            <Link to={HOME_PAGE} className="transparent-hoover-link">
              <Logo/>
            </Link>
          </div>
          <Lock
            //passwordless={"code"}
            //passwordless={"link"}
          />
        </Card>
      </Content>
      <Footer/>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/LoginOrSignUp/index.js